import { IConfigurations } from '@epicuro-next/platform/configuration';

export const SEARCH_TABLE_FEATURE_NAME = 'search-table';

export enum SearchTableRulesConfigurationKeys {
  SearchTablePageConfig = 'search-table-page-config',
}

export interface SearchTableConfiguration
  extends IConfigurations<SearchTableRulesConfigurationKeys> {
  [SearchTableRulesConfigurationKeys.SearchTablePageConfig]: string | undefined;
}

export const searchTableConfigurationDefaultValues: SearchTableConfiguration = {
  [SearchTableRulesConfigurationKeys.SearchTablePageConfig]: undefined,
};
